var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "el-form",
        { attrs: { "label-width": "120px" } },
        [
          _c(
            "el-row",
            [
              _c("BjDivider", [_vm._v("基础信息")]),
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "租户编码", prop: "tenantName" } },
                    [_vm._v(" 自动生成")]
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "租户名称", prop: "tenantName" } },
                    [
                      _c("BjInput", {
                        attrs: {
                          maxlength: _vm.MAX_LENGTH.DEFAULT,
                          placeholder: _vm.$t("inputText"),
                          clearable: "",
                        },
                        model: {
                          value: _vm.form.tenantName,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "tenantName", $$v)
                          },
                          expression: "form.tenantName",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "行业", prop: "status" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { placeholder: "请选", clearable: "" },
                          model: {
                            value: _vm.form.status,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "status", $$v)
                            },
                            expression: "form.status",
                          },
                        },
                        _vm._l(5, function (item) {
                          return _c("el-option", {
                            key: item,
                            attrs: { label: item, value: item },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "描述", prop: "tenantName" } },
                    [
                      _c("BjInput", {
                        attrs: {
                          maxlength: _vm.MAX_LENGTH.DEFAULT,
                          placeholder: _vm.$t("inputText"),
                          clearable: "",
                        },
                        model: {
                          value: _vm.form.tenantName,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "tenantName", $$v)
                          },
                          expression: "form.tenantName",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("BjDivider", [_vm._v("管理账号")]),
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "账号", prop: "name", required: "" } },
                    [
                      _c("BjInput", {
                        attrs: {
                          maxlength: _vm.MAX_LENGTH.DEFAULT,
                          placeholder: _vm.$t("inputText"),
                        },
                        model: {
                          value: _vm.form.name,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "name", $$v)
                          },
                          expression: "form.name",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "名称", prop: "nick", required: "" } },
                    [
                      _c("BjInput", {
                        attrs: {
                          maxlength: _vm.MAX_LENGTH.DEFAULT,
                          placeholder: _vm.$t("inputText"),
                          clearable: "",
                        },
                        model: {
                          value: _vm.form.nick,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "nick", $$v)
                          },
                          expression: "form.nick",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "密码", prop: "pwd" } },
                    [
                      _c("BjInput", {
                        attrs: {
                          maxlength: _vm.MAX_LENGTH.DEFAULT,
                          placeholder: _vm.$t("inputText"),
                          "show-password": "",
                          clearable: "",
                        },
                        model: {
                          value: _vm.form.pwd,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "pwd", $$v)
                          },
                          expression: "form.pwd",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c("BjFormItemMobile", {
                    attrs: { prop: "phone", label: "手机号", clearable: "" },
                    model: {
                      value: _vm.form.phone,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "phone", $$v)
                      },
                      expression: "form.phone",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c("BjFormItemEmail", {
                    attrs: { label: "邮箱", prop: "email", clearable: "" },
                    model: {
                      value: _vm.form.email,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "email", $$v)
                      },
                      expression: "form.email",
                    },
                  }),
                ],
                1
              ),
              _c("BjDivider", [_vm._v("基本配置")]),
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: "系统名称", prop: "phone", required: "" },
                    },
                    [
                      _c("BjInput", {
                        attrs: {
                          maxlength: _vm.MAX_LENGTH.DEFAULT,
                          placeholder: _vm.$t("inputText"),
                          clearable: "",
                        },
                        model: {
                          value: _vm.form.phone,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "phone", $$v)
                          },
                          expression: "form.phone",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "域名", prop: "phone", required: "" } },
                    [
                      _c("BjInput", {
                        attrs: {
                          maxlength: _vm.MAX_LENGTH.DEFAULT,
                          placeholder: _vm.$t("inputText"),
                          clearable: "",
                        },
                        model: {
                          value: _vm.form.phone,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "phone", $$v)
                          },
                          expression: "form.phone",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "有效期从",
                        prop: "strDate",
                        required: "",
                      },
                    },
                    [
                      _c("el-date-picker", {
                        staticClass: "full-width",
                        attrs: {
                          type: "datetime",
                          placeholder: _vm.$t("chooseText"),
                        },
                        model: {
                          value: _vm.form.strDate,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "strDate", $$v)
                          },
                          expression: "form.strDate",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "有效期至", prop: "endDate" } },
                    [
                      _c("el-date-picker", {
                        staticClass: "full-width",
                        attrs: {
                          type: "datetime",
                          placeholder: _vm.$t("chooseText"),
                        },
                        model: {
                          value: _vm.form.endDate,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "endDate", $$v)
                          },
                          expression: "form.endDate",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "启用", prop: "endDate" } },
                    [
                      _c("el-switch", {
                        attrs: { "active-value": 1, "inactive-value": 0 },
                        model: {
                          value: _vm.form.status,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "status", $$v)
                          },
                          expression: "form.status",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "logo", prop: "endDate" } },
                    [
                      _c(
                        "BjUpload",
                        {
                          ref: "upload",
                          staticClass: "avatar-uploader",
                          attrs: {
                            "auto-upload": "",
                            accept: "image/png,image/jpeg",
                            "accept-list": ["image/jpeg", "image/png"],
                            "limit-size": 2048,
                          },
                          on: { afterUpload: _vm.afterUpload },
                        },
                        [
                          _c(
                            "template",
                            { slot: "default" },
                            [
                              _vm.form.businessLicense
                                ? _c("BjKeyImage", {
                                    staticClass: "avatar",
                                    attrs: { url: _vm.form.businessLicense },
                                  })
                                : _c("i", {
                                    staticClass:
                                      "el-icon-plus avatar-uploader-icon",
                                  }),
                            ],
                            1
                          ),
                          _c("template", { slot: "tip" }, [
                            _vm._v(" 支持JPG/JPEG/PNG格式，图片大小不超过2M "),
                          ]),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("BjDivider", [_vm._v("菜单配置")]),
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c("BjInput", {
                    staticStyle: { width: "120px" },
                    attrs: {
                      maxlength: _vm.MAX_LENGTH.DEFAULT,
                      placeholder: "菜单名称",
                    },
                    model: {
                      value: _vm.menuName,
                      callback: function ($$v) {
                        _vm.menuName = $$v
                      },
                      expression: "menuName",
                    },
                  }),
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-left": "10px" },
                      on: { click: _vm.reSetSearchMenu },
                    },
                    [_vm._v(_vm._s(_vm.$t("resetText")))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.reFreshTree },
                    },
                    [_vm._v("查 询")]
                  ),
                  _c("el-tree", {
                    ref: "tree",
                    attrs: {
                      data: _vm.treeData,
                      props: _vm.defaultProps,
                      "show-checkbox": "",
                    },
                    on: { "node-click": _vm.handleNodeClick },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("BjDivider", [_vm._v(_vm._s(_vm.$t("operationText")))]),
      _c(
        "span",
        { staticClass: "footer", attrs: { slot: "footer" }, slot: "footer" },
        [
          _c("el-button", { on: { click: _vm.handleClose } }, [
            _vm._v(_vm._s(_vm.$t("cancelText"))),
          ]),
          _c(
            "el-button",
            {
              attrs: { type: "primary" },
              on: {
                click: function ($event) {
                  return _vm.handleConfirm("form")
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("okText")))]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }